export enum FrontendSettingsKeys {
  countersExpandStatus = 'countersExpandStatus',
  rowsPerPageGC = 'rowsPerPageGC',
  expiringDaysFilter = 'expiringDaysFilter',
  userKeywordFilter = 'userKeywordFilter',
  generalContractsFilters = 'generalContractsFilters',
  carDamagesFilters = 'carDamagesFilters',
  ODFilters = 'ODFilters',
  selectedManager = 'selectedManager',
  invoiceIdToKindFilter = 'invoiceIdToKindFilter',
  generalPageSearchString = 'generalPageSearchString',
  dashboardSearchString = 'dashboardSearchString',
  generalPageStatusFilter = 'generalPageStatusFilter',
  datesfromDC = 'datesFromDC',
  datesfromGC = 'datesFromGC',
  DCdatesRange = 'DCdatesRange',
  deltaContractsMode = 'deltaContractsMode',
  matrixViewMode = 'matrixViewMode',
  // prevPageDeltaContracts = 'prevPageDeltaContracts',
  lang = 'lang',
  deltaContractsGroupingMode = 'deltaContractsGroupingMode',
  gridGroupingMode = 'gridGroupingMode',
  gridColsVisibility = 'gridColsVisibility',
  gridColsVisibilityOrderAndDelivery = 'gridColsVisibilityOrderAndDelivery',
  generalContractsColumns = 'generalContractsColumns',
  companyFilterState = 'companyFilterState',
  ODcompanyFilterState = 'ODcompanyFilterState',
  costCenterPreselection = 'costCenterPreselection',
  costCenterPreselectionOD = 'costCenterPreselectionOD',
  modelFilterState = 'modelFilterState',
  companyIdInUsersFilter = 'companyIdInUsersFilter',
  contractStateFilterState = 'contractStateFilterState',
  contractStateFilterStateOD = 'contractStateFilterStateOD',
  expiringCompaniesTreeview = 'expiringCompaniesTreeview',
  preselectedTenantId = 'preselectedTenantId',
  preselectedCustomerId = 'preselectedCustomerId',
  userSearch = 'userSearch',
  deltaContractsCostCenterFilter = 'deltaContractsCostCenterFilter',
  excludeRestrictedDocuments = 'excludeRestrictedDocuments',
  groupIdForUserCreate = 'groupIdForUserCreate',
  groupInFilter = 'groupInFilter',
  contractDetailsYearFilterForDocuments = 'contractDetailsYearFilterForDocuments',
  driverTypePoolcars = 'driverTypePoolcars',
  driverTypeDrivers = 'driverTypeDrivers',
  driverTypeNotAssigned = 'driverTypeNotAssigned',
  requestFilter = 'requestFilter',
  version = 'version',
  orderDetails = 'orderDetails',
  OD_Columns = 'OD_Columns',
  OD_Filters_NEW = 'OD_Filters_NEW',
  isReturnActive = 'isReturnActive',
  i4uGrids = 'i4uGrids',
  iLinkGrids = 'iLinkGrids',
  iLinkOutgoingTenant = 'iLinkOutgoingTenant',
  iLinkIncomingTenant = 'iLinkIncomingTenant',
  iLinkOrderTypes = 'iLinkOrderTypes',
  supplierOrderDetails = 'supplierOrderDetails',
  iLinkContractHistory = 'iLinkContractHistory',
  lastSeenRelease = 'lastSeenRelease',
}
export enum AddressKinds {
  Primary = 'Primary',
  Invoice = 'Invoice',
  General = 'General',
  GroupPrimary = 'GroupPrimary',
  GroupGeneral = 'GroupGeneral',
  GroupInvoice = 'GroupInvoice',
  GroupTakeIn = 'GroupTakeIn',
  GroupReliefPool = 'GroupReliefPool',
  GroupShippingAddress = 'GroupShippingAddress',
  Private = 'Private',
  Amt = 'Amt',
  Correspondence = 'Correspondence',
}

export enum LocalstorageKeys {
  lastOidcError = 'last-oidc-error',
  savedUrlPath = 'savedUrlPath',
  currentUserHash = 'currentUserHash',
}

export enum ActiveServicesKindEnum {
  Rmt = 'icon-rmt',
  General = 'icon-4u',
  Transport = 'icon-4u',
  ReliefVehicle = 'icon-reliefVehicle',
  Fuel = 'icon-fuelcard',
  RoadTax = 'icon-road-tax',
  Insurance = 'icon-4u',
  Fee = 'icon-4u',
  Maintenance = 'icon-rmt',
  Tires = 'icon-tires',
  Vignette = 'icon-vignette',
  // AilLiability = "AilLiability",
  AilLiability = 'icon-liability',
  AilKasko = 'icon-kasko',
  Liability = 'icon-liability2',
  // (blank)	 = "(blank)",
  Kasko = 'icon-kasko2',
  // Blank = '(blank)',
  CarWash = 'icon-car-wash',
  MobilitySharingLicense = 'icon-4u',
  OnSiteService = 'icon-car-vip',
  Refurbishment = 'icon-car-sponge',
  Reestablishment = 'icon-car-outfit',
}

export enum VehicleNatureValue {
  Passenger = 'icon-car-big', //4254
  LightCommercial = 'icon-miniVan', //4265
  HeavyCommercial = 'icon-van-big', //4266
  Motorcycle = 'icon-motorcycle', //4267
  Bicycle = 'icon-bicycle', //4268
  Other = 'icon-car-wrap', //4269
  DeliveryTruck = 'icon-van-big', //200006
  Truck = 'icon-truck-big', //200007
  AlsoPassenger = 'icon-car-big', //200008
  AlsoMotorcycle = 'icon-motorcycle', //200063
  Undefined = 'icon-4u', //200075
  ChargingStation = 'icon-electric-station', //214373
  Trailer = 'icon-trailer', //214417
}

export enum CarDamageValue {
  Theft = 'icon-theft',
  NaturalHazard = 'icon-natural-hazards',
  GlassBreakage = 'icon-glassDamage2',
  HailDamage = 'icon-damage-hail',
  CollisionWithCar = 'icon-collision-car',
  CollisionWithObject = 'icon-collision-objects',
  CollisionWithAnimal = 'icon-collision-animals',
  MartenDamage = 'icon-damage-marten',
  ParkingDamage = 'icon-parking-damage',
  Vandalism = 'icon-vandalism',
  NoDamage = 'icon-car',
  CollisionWithPeople = 'icon-collision-people',
}

export enum ContactsKinds {
  Generic = '0',
  Homepage = 'Homepage',
  PhoneNumber = 'PhoneNumber',
  MobileNumber = 'MobileNumber',
  FaxNumber = 'FaxNumber',
  Email = 'Email',
  CorrespondenceEmail = 'CorrespondenceEmail',
  Internal = 'Internal',
  Alarm = 'Alarm',
}

export enum ManagerKinds {
  OfficeSales = 'OfficeSales',
  FleetManager = 'FleetManager',
}

export enum ManagersContactsKinds {
  Homepage = 'Homepage',
  PhoneNumber = 'PhoneNumber',
  MobileNumber = 'MobileNumber',
  FaxNumber = 'FaxNumber',
  Email = 'Email',
  InternalNumber = 'InternalNumber',
  AlarmNumber = 'AlarmNumber',
  DirectNumber = 'DirectNumber',
  PrivateNumber = 'PrivateNumber',
  InvoiceEmail = 'InvoiceEmail',
  IntranetLink = 'IntranetLink',
  IntranetTechLink = 'IntranetTechLink',
  SupplierTermsLink = 'SupplierTermsLink',
  PartnerProfileLink = 'PartnerProfileLink',
  CorrespondenceEmail = 'CorrespondenceEmail',
  InsuranceClaimsEmail = 'InsuranceClaimsEmail',
}

export enum ContractStateEnum {
  Default = 'Default',
  Closed = 'Closed',
  Running = 'Running',
  Terminated = 'Terminated',
  Extended = 'Extended',
  Initialized = 'Initialized',
  Canceled = 'Canceled',
  Ordered = 'Ordered',
  Expiring = 'Expiring',
  SettingUp = 'SettingUp',
}

export enum ProductTypeEnum {
  GMLeasing = 'GM-Leasing',
  GMLeasingGold = 'GM-Leasing Gold',
  FullServiceLease = 'Full Service Lease',
  ManagementOnly = 'Management Only',
  DCSLMOoffen = 'DCSL MO - offen',
  Medlease = 'Medlease',
  GM = 'GM',
  PTMFullGeschlossen = 'PTMFullGeschlossen',
  FullDistance = 'FullDistance',
  EFLLagerfinanzierungPhase1 = 'EFL Lagerfinanzierung Phase 1',
  ExternalFin = 'ExternalFin',
  Fin = 'Fin',
  FinPlus = 'FinPlus',
  FullClosed = 'FullClosed',
  FullOpen = 'FullOpen',
  FullOpenPlus = 'FullOpenPlus',
  Mo = 'Mo',
  MoClosed = 'MoClosed',
  SimpleXFleet = 'SimpleXFleet',
  Mitarbeiterleasing = 'Mitarbeiterleasing',
}

export enum PermissionsEnum {
  ReportsView = 'reports.view',
  RequestsApprove = 'orders.approve',
  OrdersManage = 'orders.manage',
  DocumentsView = 'documents.view',
  CostsView = 'costs.view',
  IncomingView = 'incoming.view',
  OutgoingView = 'outgoing.view',
  WorkItemsView = 'workitems.view',
}
export enum ReportsVisibility {
  Public = 'Public',
  Private = 'Private',
  Internal = 'Internal',
}
export enum LocaleEnum {
  En = 'en-US',
  De = 'de-CH',
  It = 'it-CH',
  Fr = 'fr-CH',
}

export enum ApprovalStepTypeEnum {
  Default = 'DEFAULT',
  Bu = 'BU',
  Com = 'COM',
}

export enum Environment {
  Development = 'development',
  Staging = 'staging',
  Demo = 'demo',
  Integration = 'integration',
  Production = 'production',
  Unknown = 'unknown',
}

export enum SpecialRequestFormField {
  CustomersSelect = 'customersSelect',
  CustomersSelectUnlinked = 'customersSelectUnlinked',
  UnitsSelect = 'unitsSelect',
  ZipSearch = 'zipSearch',
  UnitsSelectUnlinked = 'unitsSelectUnlinked',
  FuelSelect = 'fuelSelect',
}

export enum Cantons {
  AG,
  AR,
  AI,
  BL,
  BS,
  BE,
  FR,
  GE,
  GL,
  GR,
  JU,
  LU,
  NE,
  NW,
  OW,
  SH,
  SZ,
  SO,
  SG,
  TG,
  TI,
  UR,
  VS,
  VD,
  ZG,
  ZH,
}

export enum WorkflowOrderStepStatus {
  New = 'New',
  InProgress = 'InProgress',
  Done = 'Done',
  Pending = 'Pending',
  OnHold = 'OnHold',
  Cancelled = 'Cancelled',
  Recreated = 'Recreated',
}

export enum WorkflowOrderType {
  Internal = 'Internal',
  Suppliers = 'Suppliers',
}

export enum OracleDbType {
  Char = 'Char',
  Date = 'Date',
  Decimal = 'Decimal',
  Double = 'Double',
  Long = 'Long',
  Int16 = 'Int16',
  Int32 = 'Int32',
  Int64 = 'Int64',
  NVarchar2 = 'NVarchar2',
  Varchar2 = 'Varchar2',
  Boolean = 'Boolean',
}

export enum EntityKind {
  Customer = 0x0a,
  Unit = 0xfa,
  Contract = 0x0c,
  Service = 0xcc,
  Vehicle = 0xec,
}

export interface DriverFilter {
  pool_cars: boolean
  drivers: boolean
  not_assigned: boolean
  searchString: string
}

export enum DeltaGridColEnum {
  months = 'months',
  monthsDifForGrid = 'monthsDifForGrid',
  customerName = 'customerName',
  kind = 'kind',
  km = 'km',
  kmDiff = 'kmDiff',
  total = 'total',
  totalPercent = 'totalPercent',
  delta = 'delta',
}
